import { mixed, object, string } from 'yup';
import type { FileInputDto } from '../file/model';

export interface VideoReplicationResultDraft {
  script?: string;
  reference_images?: FileInputDto[];
}

const videoReplicationResultDraftSchema = object({
  script: string().optional(),
  reference_images: mixed<FileInputDto[]>().optional(),
});

export function getVideoReplicationResultDraftStorageKey(
  accountId: string,
  taskId: string,
) {
  return `${accountId}_v2_video_replication_result_${taskId}`;
}

export function isVideoReplicationResultDraft(
  value: object,
): value is VideoReplicationResultDraft {
  return videoReplicationResultDraftSchema.isValidSync(value);
}
